import React from "react";
import "../pages/landing/landing.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    error.__ErrorBoundary = true;
    window.__COMPONENT_ERROR__?.(error, errorInfo);
    // console.log("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state?.hasError) {
      return (
        <div className="lp flex min-h-screen flex-col items-center justify-center px-4 text-center">
          <p className="lp-kicker">Algo ha fallado</p>
          <h1 className="lp-display mt-5 text-[clamp(2.4rem,6vw,4rem)]">Ha habido un error.</h1>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-[var(--lp-muted)]">
            Vuelve al inicio y prueba de nuevo. Si sigue pasando, cuéntanoslo.
          </p>
          <button type="button" onClick={() => { window.location.href = "/"; }} className="lp-btn mt-10">
            Volver al inicio
          </button>
        </div>
      );
    }

    return this.props?.children;
  }
}

export default ErrorBoundary;